/*
 * Implement ExportOptions for KPI Card as we only need to support PNG export.
 */
import React from 'react';
import {
  AnchorButton,
  Checkbox,
  Icon,
  Position,
} from '@blueprintjs/core';
import {IconNames} from '@blueprintjs/icons';
import {Popover2} from '@blueprintjs/popover2'

import {IBlock} from '../../../models';
import {
  getExportOptionsFromBlock,
} from '../components';

import '../components/ExportOptions/ExportOptions.scss';

type OnChangeCallback = (value: any) => void;

interface ExportOptionsProps {
  show: boolean;
  block: IBlock | null;
  onChange: OnChangeCallback;
  disabled?: boolean;
}

interface ExportOptionProps {
  embed: boolean;
  onChange: OnChangeCallback;
}

const ExportOption = ({
  embed = true,
  onChange,
}: ExportOptionProps) => {
  const _onChange = (event: any) => {
    onChange(event.target.checked);
  }

  return (
    <div className="export-options-popover">
      <div className="title">Export Options</div>
      <div className="selected-option-content">
        <Checkbox
          label="Embed KPI Card image in email body"
          defaultChecked={embed}
          onChange={_onChange}
        />
      </div>
    </div>
  )
};

export const ExportOptions = React.memo(({
  show,
  block,
  onChange,
  disabled = false,
}: ExportOptionsProps) => {
  if (!show) {
    return null;
  }
  const exportOptions = getExportOptionsFromBlock(block as IBlock);

  return (
    <div className="export-options">
      <Icon icon={IconNames.NEST}/>
      <Popover2
        content={
          <ExportOption
            embed={exportOptions?.embed}
            onChange={onChange}
          />
        }
        position={Position.BOTTOM_RIGHT}
      >
        <AnchorButton
          small={true}
          text={`embed: ${exportOptions?.embed ? 'yes' : 'no'}`}
          icon={IconNames.PAPERCLIP}
          rightIcon={IconNames.COG}
          disabled={disabled}
        />
      </Popover2>
    </div>
  );
});

export default ExportOptions;
